module.exports = __webpack_public_path__ + "static/media/permanent-mission-canada-logo.d76c1e46.png";